// extracted by mini-css-extract-plugin
export default {"hook":"StarPickerInput_hook__XfWo3"};